import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import axios from 'src/api/Api';
import {
    GET_TEMPLATE_DETAILS_SUCCESS,
    GET_TEMPLATE_DETAILS_FAILURE,
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* getTemplateDetails(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/productTemplates/templatesdetails/${action.payload}?templateSubType=${
        action?.templatecategory ? action.templatecategory : 'USER'
    }`;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        yield put({
            type: GET_TEMPLATE_DETAILS_SUCCESS,
            payload: result || {},
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
        });
        yield put({
            type: GET_TEMPLATE_DETAILS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
